import * as MC from "@mantine/core";
import * as TI from "@tabler/icons-react";
import { calculatePagination } from "../utils/utils";

const SkipPrevIcon = () => <TI.IconPlayerSkipBackFilled style={{ width: 12, height: 12 }} />;
const PrevIcon = () => <TI.IconCaretLeftFilled style={{ width: 15, height: 15 }} />;
const NextIcon = () => <TI.IconCaretRightFilled style={{ width: 15, height: 15 }} />;
const SkipNextIcon = () => <TI.IconPlayerSkipForwardFilled style={{ width: 12, height: 12 }} />;

interface IAppPaginationProps extends Omit<MC.PaginationProps, "total"> {
  chunkedTotal?: number;
  total?: number;
  withDetails?: boolean;
  rowTotal?: number;
}

export default function AppPagination(props: IAppPaginationProps) {
  const theme = MC.useMantineTheme();

  const total = calculatePagination(props.total || 0);
  const chunkedTotal = props.chunkedTotal;

  const renderComponent = () => {
    return (
      <MC.Group
        w="100%"
        py={"xl"}
        align="center"
        justify={props.withDetails ? "space-between" : "flex-end"}
        mt="lg"
        data-testid="apppagination-main-group"
      >
        {props.withDetails && (
          <MC.Text data-testid="apppagination-details-text">
            Pág. {Number(props?.value)} de {chunkedTotal ?? total}{" "}
            {props.total ? `(${props.total} encontrados)` : ""}
          </MC.Text>
        )}
        <MC.Pagination.Root
          total={chunkedTotal ?? total}
          value={props.value}
          onChange={(page) => {
            props.onChange?.(page);
          }}
          onFirstPage={() => props.onChange?.(1)}
          onLastPage={() => props.onChange?.(total)}
          onNextPage={() => props.onChange?.(Number(props?.value) + 1)}
          onPreviousPage={() => props.onChange?.(Number(props?.value) - 1)}
          size={"sm"}
          data-testid="apppagination-root"
        >
          <MC.Group gap={5} justify="center" data-testid="apppagination-buttons-group">
            <MC.Pagination.First
              icon={SkipPrevIcon as React.FC}
              style={{
                backgroundColor: "#00b4cc",
                color: theme.white
              }}
              data-testid="apppagination-first"
            />
            <MC.Pagination.Previous
              icon={PrevIcon as React.FC}
              style={{
                backgroundColor: "#00b4cc",
                color: theme.white
              }}
              data-testid="apppagination-previous"
            />
            <MC.Pagination.Items data-testid="apppagination-items" />
            <MC.Pagination.Next
              icon={NextIcon as React.FC}
              style={{
                backgroundColor: "#00b4cc",
                color: theme.white
              }}
              data-testid="apppagination-next"
            />
            <MC.Pagination.Last
              icon={SkipNextIcon as React.FC}
              style={{
                backgroundColor: "#00b4cc",
                color: theme.white
              }}
              data-testid="apppagination-last"
            />
          </MC.Group>
        </MC.Pagination.Root>
      </MC.Group>
    );
  };

  return renderComponent();
}
